import * as React from 'react'
import { Formik } from 'formik'

import type { DraftLead } from '@user/store/draftLeads/typings'

import { UpdateRequiredFieldsForm } from './UpdateRequiredFieldsForm'
import { useData } from './hooks/useData'
import { useHandlers } from './hooks/useHandlers'
import { useInitialValues } from './hooks/useInitialValues'
import type { AutoReviewFormValues } from './hooks/useInitialValues'
import { useValidate } from './hooks/useValidate'

interface Props {
  lead: DraftLead
  onClose: () => void
}

export function UpdateRequiredFieldsContent(props: Props) {
  const { lead, onClose } = props

  const data = useData(lead)
  const initialValues = useInitialValues(
    lead,
    data.customFields,
    data.targetPests,
  )
  const validate = useValidate({
    editableMissing: data.editableMissing,
  })
  const { onSubmit } = useHandlers({
    lead,
    editableMissing: data.editableMissing,
    lookups: data.lookups,
    onClose,
  })

  return (
    <Formik<AutoReviewFormValues>
      enableReinitialize
      initialValues={initialValues}
      onSubmit={onSubmit}
      validate={validate}
    >
      <UpdateRequiredFieldsForm data={data} onClose={onClose} />
    </Formik>
  )
}

UpdateRequiredFieldsContent.displayName = 'UpdateRequiredFieldsContent'
